import _ from 'lodash'

import { mapMutations } from 'vuex'

//import SETTINGS from '@/plugins/settings'

import Category from '@/models/category'
import Collection from '@/models/collection'
import Cta from '@/models/cta'
import Issue from '@/models/issue'
import Library from '@/models/library'

const Utility = {

  computed:
  {
    /*
    appName()
    {
      return SETTINGS.APP_NAME
    },
    */

    isMobile()
    {
      return this.$vuetify.breakpoint.smAndDown
    },

    isSmartphone()
    {
      return this.$vuetify.breakpoint.xs
    }
  },

  methods:
  {
    ...mapMutations({
      setBack: 'ui/setBack'
    }),

    goTo(where)
    {
       if( typeof where == 'string' )
         where = { name:where }

       this.$router.push(where).catch(()=>{})
    },

    hideBack()
    {
      this.setBack(null)
    },

    mapModel(model, classToMap='library')
    {
      return this.mapModels([model], classToMap)[0]
    },

    mapModels(models=[], classToMap='library')
    {
      return _.map(models, (model)=>{

        switch( classToMap.toLowerCase() ){
          case 'category': return new Category(model)
          case 'collection': return new Collection(model)
          case 'cta': return new Cta(model)
          case 'issue': return new Issue(model)
          case 'library': return new Library(model)
          default: return model
        }

      })
    },

    scrollTo(el) 
    {
      this.$vuetify.goTo( `#${el}`, { offset: 60 })
    },

    /*
    storageUrl(append="")
    {
      return `${SETTINGS.BACKEND_URL}storage/${append}`
    }
    */

  }
}

export default Utility